import { ISelectInputOption, ISelectInputProps, SelectInput } from "@rocketmakers/armstrong";
import * as React from "react";

export interface IFilterSelectProps extends ISelectInputProps {
	filterOptions?: any[];
}

export const FilterSelect: React.FunctionComponent<IFilterSelectProps> = ({ options, filterOptions, ...props }) => {
	const filteredOptions: ISelectInputOption[] = React.useMemo(
		() => (options ? options.filter(({ id }) => !(filterOptions ?? []).includes(id)) : undefined),
		[options, filterOptions],
	);

	return <SelectInput data-qa="filter-select" {...props} options={filteredOptions} />;
};
